import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/GridLegacy';

const FaqsPageSkeletonLoading = () => (
	<Grid container spacing={2} data-testid='skeletonLoading'>
		{[0, 1, 2, 3].map(index => (
			<Grid item xs={12} key={`skeleton-${index}`}>
				<Skeleton variant='text' height={40} width='80%' />
				<Skeleton variant='text' height={20} width='100%' />
				<Skeleton variant='text' height={20} width='100%' />
				<Skeleton variant='text' height={20} width='100%' />
			</Grid>
		))}
	</Grid>
);

export default FaqsPageSkeletonLoading;
